export default __webpack_public_path__ + "static/wood-style-1-0384df4c7611ccae4ccc6cad742a4c0b.png";